import { Button } from "components/DesignSystem/Button/Button";
import { TextInput } from "components/DesignSystem/TextInput/TextInput";
import { Cross } from "components/icons/Cross";
import { RoleAppointmentFields } from "./RoleAppointmentFields";

type OtherRoleCardProps = {
  index: number;
  isLocked: boolean;
  onRemove: () => void;
};

export const OtherRoleCard = ({
  index,
  isLocked,
  onRemove,
}: OtherRoleCardProps) => (
  <div className="t-flex t-flex-col t-gap-3 t-rounded t-bg-surface-lighter-grey t-p-4">
    <div className="t-flex t-items-center t-justify-between">
      <div className="t-text-subtext-sm t-text-text-60">Other role</div>
      {!isLocked && (
        <Button
          type="button"
          customType="ghost_icon"
          size="xsmall"
          onClick={onRemove}
        >
          <Cross color="currentColor" />
        </Button>
      )}
    </div>
    <TextInput
      block
      required
      customSize="small"
      label="Enter role name"
      placeholder="Enter role"
      name={`otherRoles.${index}.roleName`}
    />
    <RoleAppointmentFields namePrefix={`otherRoles.${index}`} />
  </div>
);
